import React from "react";

const Marquee = () => {
  const items = [
    "Se apaga al 100%",
    "FullStop",
    "USB-C · 140W",
    "Cuida tu batería",
    "Carga y olvídate",
  ];
  // Three loops for seamless marquee; each item gets a stable key combining content + loop.
  const sequence = [0, 1, 2].flatMap((loop) =>
    items.map((label) => ({ key: `${label}-${loop}`, label }))
  );

  return (
    <section data-testid="marquee-section" className="relative py-16 overflow-hidden border-y border-white/10">
      <div className="marquee flex gap-12 whitespace-nowrap">
        {sequence.map((item) => (
          <div key={item.key} className="flex items-center gap-12 shrink-0">
            <span className="font-display text-5xl md:text-7xl font-extrabold tracking-tighter text-white/90">
              {item.label}
            </span>
            <span className="text-3xl text-[#ff9eeb]">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
